import { useParams } from 'react-router';

import Box from '@/design_system/Box';
import Stack from '@/design_system/Stack';
import { useBrand } from '@/models/brand';

import { ContractualObligationToHandle } from './ContractualObligationToHandle';
import { DepositPercentages } from './DepositPercentages';
import { OwnedByOrganization } from './OwnedByOrganization';

export const OverviewTab = () => {
  const { id } = useParams();
  const { data: brand } = useBrand(id);

  if (!brand) {
    return null;
  }

  return (
    <Box>
      <Stack gap="1em">
        <ContractualObligationToHandle brand={brand} />
        <OwnedByOrganization brand={brand} />
        <DepositPercentages brand={brand} />
      </Stack>
    </Box>
  );
};
